import { PulseBaseProvider } from '../../base-classes';
import { getTemperature, getPressure, getSpeed } from '../../utilities/unitConversion';
import { unitSystems } from '../../utilities/units';

const _hourlyForecastUri = '/data/forecasts/v3/hourly';
const _hourlyForecastCacheKey = 'hourlyForecast';


export class HourlyForecastProvider extends PulseBaseProvider {
    constructor(baseUrl, authId, secret, options, logger) {
        super(baseUrl, authId, secret, options, logger);
        this.storage.sync[_hourlyForecastCacheKey] = this.hourlyForecastSyncer.bind(this);
    }

    async hourlyForecastSyncer(params) {
        const { id, syncParams, resolve, reject } = params;

        const queryParams = {
            ...syncParams.stdParameters,
            location: syncParams.location,
            locationtype: syncParams.locationtype,
            offset: syncParams.offset,
            length: syncParams.length,
            units: unitSystems.english,
            verbose: syncParams.verbose
        };

        const { tempUnit, pressureUnit, speedUnit } = syncParams;
        const hourlyUnitConversionFunc = (result) => {
            if (result?.hourlyForecastPeriod?.length > 0) {
                result.hourlyForecastPeriod.forEach(item => { 
                    item.dewPoint = getTemperature(item.dewPoint, tempUnit);
                    item.feelsLike = getTemperature(item.feelsLike, tempUnit);
                    item.windSpeed = getSpeed(item.windSpeed, speedUnit);
                    item.surfacePressure = getPressure(item.surfacePressure, pressureUnit);
                    item.globeTemperature = getTemperature(item.globeTemperature, tempUnit);
                    item.wetBulbTemperature = getTemperature(item.wetBulbTemperature, tempUnit);
                    item.temperature = getTemperature(item.temperature, tempUnit);
                }); 
            } else if (result?.hfp?.length > 0) {
                result.hfp.forEach(item => { 
                    item.dp = getTemperature(item.dp, tempUnit);
                    item.fl = getTemperature(item.fl, tempUnit);
                    item.ws = getSpeed(item.ws, speedUnit);
                    item.sp = getPressure(item.sp, pressureUnit);
                    item.gt = getTemperature(item.gt, tempUnit);
                    item.wbt = getTemperature(item.wbt, tempUnit);
                    item.t = getTemperature(item.t, tempUnit);
                });    
            }
        
            return result;
        };

        const responseValidator = response => {
            return !!response;
        };

        return await super.syncData(syncParams.key, id, queryParams, _hourlyForecastUri, resolve, reject, responseValidator, syncParams.pulseApi, null, hourlyUnitConversionFunc, true, syncParams.cacheDuration);
    }

    async getHourlyForecast(location, locationtype, offset, length, units, stdParameters, verbose, refresh = false, tempUnit, pressureUnit, speedUnit, cacheDuration) {
        const syncParams = {
            location,
            locationtype,
            offset: offset && offset >= 0 ? offset : 0,
            length: length && length >= 0 ? length : 0,
            verbose: !!verbose,
            refresh,
            tempUnit,
            pressureUnit,
            speedUnit
        };
        const id = JSON.stringify(syncParams);
        syncParams.cacheDuration = cacheDuration;

        //Add the standard parameters after generating the ID because they shouldn't be part of the cache key
        syncParams.stdParameters = stdParameters;

        if (refresh) {
            super.removeFromStorage(_hourlyForecastCacheKey, id);
        }
        return await super.loadFromStorage(_hourlyForecastCacheKey, id, syncParams);
    }
}
